import { basicApi } from '../utils/api';

export interface SolapiConnection {
  connectionId: number;
  name: string;
  status: string;
  apiKeyPrefix: string;
  webhookConfigured: boolean;
}

export interface SolapiConnectionUpsert {
  name: string;
  apiKey: string;
  apiSecret: string;
  webhookSecret?: string;
}

export const getSolapiConnection = async () =>
  (await basicApi.get<SolapiConnection | null>('/solapi/connection')).data;

export const saveSolapiConnection = async (body: SolapiConnectionUpsert) =>
  (await basicApi.put<SolapiConnection>('/solapi/connection', body)).data;
